import { render } from "./RegisterProducts.vue?vue&type=template&id=289d6cb4"
import script from "./RegisterProducts.vue?vue&type=script&lang=js"
export * from "./RegisterProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__